import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';

var GoogleSheetsLogo = function GoogleSheetsLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M271.25 0H40.6875C18.3094 0 0 16.3841 0 36.4091V497.591C0 517.616 18.3094 534 40.6875 534H393.312C415.69 534 434 517.616 434 497.591V145.636L339.062 84.9545L271.25 0Z",
      fill: "#0F9D58"
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.5 260.932V436.909H325.5V260.932H108.5ZM203.438 412.637H135.625V382.296H203.438V412.637ZM203.438 364.091H135.625V333.75H203.438V364.091ZM203.438 315.546H135.625V285.205H203.438V315.546ZM298.375 412.637H230.563V382.296H298.375V412.637ZM298.375 364.091H230.563V333.75H298.375V364.091ZM298.375 315.546H230.563V285.205H298.375V315.546Z",
      fill: "#F1F1F1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M271.249 0V109.227C271.249 129.343 289.457 145.636 311.936 145.636H433.999L271.249 0Z",
      fill: "#87CEAC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.6875 0C18.3094 0 0 16.3841 0 36.4091V39.4432C0 19.4182 18.3094 3.03409 40.6875 3.03409H271.25V0H40.6875Z",
      fill: "white",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M393.312 530.965H40.6875C18.3094 530.965 0 514.581 0 494.556V497.59C0 517.615 18.3094 534 40.6875 534H393.312C415.69 534 434 517.615 434 497.59V494.556C434 514.581 415.69 530.965 393.312 530.965Z",
      fill: "#263238",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M311.936 145.636C289.457 145.636 271.249 129.343 271.249 109.227V112.261C271.249 132.377 289.457 148.67 311.936 148.67H433.999V145.636H311.936Z",
      fill: "#263238",
      fillOpacity: "0.1"
    })]
  }));
};

GoogleSheetsLogo.defaultProps = {
  width: "434",
  height: "534",
  viewBox: "0 0 434 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SharedWidgetSpreadsheetLink = _ref => {
  let {
    href,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs("a", {
    target: "_blank",
    rel: "noreferrer",
    href: href,
    className: clsx(styles.link, className || ''),
    children: [/*#__PURE__*/_jsx("u", {
      children: "View Spreadsheet"
    }), " ", /*#__PURE__*/_jsx(GoogleSheetsLogo, {})]
  });
};

export default SharedWidgetSpreadsheetLink;